import Vue from 'vue';
import store from '@/store';
import OrderProxy from "../../../proxies/OrderProxy";
import * as types from './mutation-types';

/**
 * 발주내역
 * @param commit
 * @param param
 */
export const findAll = ({ commit }) => {
  new OrderProxy()
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

/**
 * 발주 선택 삭제
 * @param commit
 * @param list
 */
export const deleteById = ({ commit }, list) => {
  new OrderProxy()
    .deleteById(list)
    .then((response) => {
      store.dispatch('order/findAll');
    });
};

/**
 * 발주 전체 삭제
 * @param commit
 */
export const deleteAll = ({ commit }) => {
  new OrderProxy()
    .deleteAll()
    .then((response) => {
      store.dispatch('order/findAll');
    });
};


export default {
  findAll,
  deleteById,
  deleteAll,
};
